module.exports = __webpack_public_path__ + "img/header-right.b6a3cef0.png";